import styled from 'styled-components'
import { Colors, Breakpoints } from './../../utils/variables'

export const StyledLayout = styled.main`
    overflow: hidden;
    
    padding-bottom: 30px;

    background-color: ${props => (props.page === 'home') ? `${Colors.whiteBroken}` : `transparent`};

    @media screen and (min-width: ${Breakpoints.wide}) {
        padding-bottom: 50px;

        background-color: ${props => (props.page === 'home') ? `${Colors.white}` : `transparent`};
    }
`